import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { ViewGoalsModule } from 'src/app/dashboard/goals-progress/view-goals/view-goals.module';
import { AutoSaveModule } from 'src/app/shared/components/autosave/autosave.module';
import { QuestionTypesModule } from 'src/app/shared/components/question-types/question-types.module';
import { StepDescriptionModule } from 'src/app/shared/components/step-description/step-description.module';
import { NewGoalsInputModule } from 'src/app/shared/modals/new-goals-input/new-goals-input.module';
import { PipesModule } from 'src/app/shared/pipes/pipes.module';
import { UtilService } from 'src/app/shared/services/util.service';
import { AuthGuard } from '../shared/guards/auth.guard';
import { PageTitleInterface } from '../shared/interfaces/page-title.interface';
import { GoalsInputPage } from './goals-input/goals-input.page';
import { GoalsInputFeedbackPage } from './goals-input/goals-input-feedback/goals-input-feedback.page';
import { GoalsReviewPage } from './goals-review/goals-review.page';
import { GoalsReviewValidationPage } from './goals-review-validation/goals-review-validation.page';
import { ReviewInputValidationPage } from './goals-review-validation/review-input-validation/review-input-validation.page';
import { GoalsService } from './goals.service';
import { GoalsValidationPage } from './goals-validation/goals-validation.page';
import { GoalsInputReviewPage } from './goals-validation/goals-input-review/goals-input-review.page';
import { UserGoalsListComponent } from './components/user-goals-list/user-goals-list.component';
import { SubordinateProfileComponent } from './components/subordinate-profile/subordinate-profile.component';

const routes: Routes = [
  {
    path: 'goals-input/:cycleId',
    canActivate: [AuthGuard],
    data: { title: PageTitleInterface.GoalsInput },
    component: GoalsInputPage
  },
  {
    path: 'goals-validation/:cycleId',
    canActivate: [AuthGuard],
    data: { title: PageTitleInterface.GoalsValidation },
    component: GoalsValidationPage
  },
  {
    path: 'goals-validation/:cycleId/:goalId',
    canActivate: [AuthGuard],
    data: { title: PageTitleInterface.GoalsValidationInput },
    component: GoalsInputReviewPage
  },
  {
    path: 'goals-review/:cycleId',
    canActivate: [AuthGuard],
    data: { title: PageTitleInterface.GoalsReview },
    component: GoalsReviewPage
  },
  {
    path: 'goals-review-validation/:cycleId',
    canActivate: [AuthGuard],
    data: { title: PageTitleInterface.GoalsReviewValidation },
    component: GoalsReviewValidationPage
  },
  {
    path: 'goals-review-validation/:cycleId/:userId',
    canActivate: [AuthGuard],
    component: ReviewInputValidationPage
  }
];

@NgModule({
  declarations: [
    GoalsInputPage,
    GoalsInputFeedbackPage,
    GoalsValidationPage,
    GoalsInputReviewPage,
    GoalsReviewPage,
    GoalsReviewValidationPage,
    ReviewInputValidationPage,
    UserGoalsListComponent,
    SubordinateProfileComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes),
    PipesModule,
    StepDescriptionModule,
    ViewGoalsModule,
    ReactiveFormsModule,
    AutoSaveModule,
    QuestionTypesModule,
    NewGoalsInputModule,
  ],
  providers: [
    GoalsService,
    UtilService
  ]
})
export class GoalsModule { }
